import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 26"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_103_3177)" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13 2.343c3.471 0 3.883.013 5.254.076 3.523.16 5.169 1.832 5.33 5.329.062 1.37.074 1.782.074 5.253 0 3.472-.013 3.883-.075 5.253-.161 3.494-1.803 5.169-5.329 5.33-1.371.062-1.78.075-5.254.075-3.471 0-3.883-.013-5.253-.076-3.532-.161-5.169-1.84-5.329-5.33-.063-1.37-.076-1.78-.076-5.253 0-3.471.014-3.882.076-5.253.161-3.496 1.803-5.169 5.329-5.329 1.371-.062 1.782-.075 5.253-.075ZM13 0C9.47 0 9.027.015 7.64.078 2.92.295.297 2.914.08 7.64.014 9.027 0 9.47 0 13c0 3.53.015 3.974.078 5.36.217 4.721 2.836 7.345 7.562 7.562C9.027 25.985 9.47 26 13 26c3.53 0 3.974-.015 5.36-.078 4.717-.217 7.348-2.836 7.56-7.562.065-1.386.08-1.83.08-5.36 0-3.53-.015-3.973-.078-5.36-.212-4.716-2.835-7.344-7.56-7.56C16.973.014 16.53 0 13 0Zm0 6.324a6.676 6.676 0 1 0 0 13.352 6.676 6.676 0 0 0 0-13.351Zm0 11.01a4.333 4.333 0 1 1-.001-8.666A4.333 4.333 0 0 1 13 17.333ZM19.94 4.5a1.56 1.56 0 1 0-.001 3.121 1.56 1.56 0 0 0 0-3.12Z" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }